export const activityOptions = [
    { label: "Nova reserva", value: "RESERVATION_CREATE" },
    { label: "Reserva cancelada", value: "RESERVATION_CANCEL" },
    { label: "Reserva paga", value: "RESERVATION_PAID" },
    { label: "Data de entrada", value: "CHECKIN_DATE" },
    { label: "Data de saída", value: "CHECKOUT_DATE" },
    { label: "Check-In realizado", value: "CHECKIN_CREATE" },
    { label: "Check-Out realizado", value: "CHECKOUT_CREATE" },
]